module.exports = __webpack_public_path__ + "img/star_empty.1e4a20af.svg";